// Runtime config read from window.__ATLAS_CONFIG__, populated by /config.js.
// Layout loads <script src="/config.js"> synchronously, so the global is set
// before any module that calls getRuntimeConfig() runs.
//
// At deploy time, Ansible writes dist/config.js per environment (see
// atlas-international-playbooks/roles/atlas-front-end/tasks/inject-config.yml).
// During `pnpm dev`, a Vite middleware (vite.config.ts) serves /config.js with
// values built from .env. The checked-in public/config.js is the empty-defaults
// fallback used by `pnpm preview` and any deploy where Ansible hasn't run.
//
// This means one GitHub Actions build can be deployed to validation, prod, or
// any other environment without rebuilding — secrets and per-env values live
// in ansible group_vars, not in the bundle.

export type AtlasRuntimeConfig = {
  sentryDsn?: string;
  sentryEnv?: string;
  sentryTracesSampleRate?: number;
  sentryReplaysSessionSampleRate?: number;
  sentryReplaysOnErrorSampleRate?: number;
  gaTrackingId?: string;
  googleApiKey?: string;
  version?: string;
};

declare global {
  interface Window {
    __ATLAS_CONFIG__?: AtlasRuntimeConfig;
  }
}

const CONFIG: AtlasRuntimeConfig =
  (typeof window !== "undefined" && window.__ATLAS_CONFIG__) || {};

export function getRuntimeConfig(): AtlasRuntimeConfig {
  return CONFIG;
}
